import { get } from './_core.js';

export interface AuditItem {
  id: string;
  adminUserId: string;
  adminEmail: string | null;
  action: string;
  targetKind: string;
  targetId: string;
  metadata: unknown;
  at: string;
}

export interface AuditFilters {
  adminUserId?: string | undefined;
  action?: string | undefined;
  targetKind?: string | undefined;
  targetId?: string | undefined;
  from?: string | undefined;
  to?: string | undefined;
  cursor?: string | undefined;
}

export async function fetchAudit(
  filters: AuditFilters = {},
): Promise<{ items: AuditItem[]; nextCursor: string | undefined }> {
  const params = new URLSearchParams();
  if (filters.adminUserId) params.set('admin_user_id', filters.adminUserId);
  if (filters.action) params.set('action', filters.action);
  if (filters.targetKind) params.set('target_kind', filters.targetKind);
  if (filters.targetId) params.set('target_id', filters.targetId);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.cursor) params.set('cursor', filters.cursor);
  const qs = params.toString();
  const res = await get<{ items: AuditItem[] }>(`/admin/audit${qs ? `?${qs}` : ''}`);
  return { items: res.data.items, nextCursor: res.meta?.nextCursor };
}
